import { Minus } from "lucide-react";

import { Helmet } from 'react-helmet';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
const Conference = () => {
  const images = [
  { id: 1, src: '/images/corpo/conference-all_.jpg', title: 'CONFERENCES' },
  { id: 2, src: '/images/home/hall-area_.jpg', title: 'Card Two' },
  { id: 3, src: '/images/home/front-view_.jpg', title: 'Card Three' },
];
  return (


     
    <>
    
    <div className="text-center my-2 px-3" id="events">
      <h3 className="fw-bold mb-3">
        <span className=" corpo-conference py-2">
        <Minus/>  CONFERENCES AND EVENTS<Minus/>
        </span>
      </h3>
      
      <p className=" corpo-conference-para mx-auto" style={{ maxWidth: "700px" }}>
      Host your next conference in Mahipalpur, Delhi with effortless style. Our curated collection of corporate halls and banquet spaces are ideal for corporate events, team meetings, business conferences, and private corporate lunches or dinners. Located near  IGI Airport, V Hotel The Grand Shoba is your premium choice for Delhi corporate gatherings. Discover elevated event experiences in the heart of Mahipalpur—where business meets excellence.
      </p>
    <Link  title='v hotel the grand shoba corporate-query' to="/corporate-query" >
      <button className=" conference-btn   my-3 px-4">
        ENQUIRE NOW
      </button>
      </Link>
    
    </div>




 <Container className="my-5">
      <Row>
        {images.map((img) => (
          <Col key={img.id} xs={12} sm={6} md={4} className="mb-4">
            <div
              className="conference-card-parent card-container"
              style={{ backgroundImage: `url(${img.src})` }}
            >
              <div className="card-content">
                {/* <h5 className="text-center">{img.title}</h5> */}
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>

 


    </>
  );
};

export default Conference;
